export const KA_FLEET_THRESHOLD = 100;

export const KA_GOAL_PCT = 80;
export const SMB_GOAL_PCT = 90;

export type CompletionTier = 'KA' | 'SMB';

type GetCompletionGoalPctInput = {
  fleetSize: number;
  tier?: CompletionTier | null;
};

export const getCompletionGoalPct = ({ fleetSize, tier }: GetCompletionGoalPctInput): number => {
  if (tier === 'KA') return KA_GOAL_PCT;
  if (tier === 'SMB') return SMB_GOAL_PCT;
  return fleetSize >= KA_FLEET_THRESHOLD ? KA_GOAL_PCT : SMB_GOAL_PCT;
};
